export const FEED_ORDER_CAPTURE = 'FEED_ORDER_CAPTURE';
export const FEED_ORDER_RELEASE = 'FEED_ORDER_RELEASE';
